import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ testId, className = "", ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        {...props}
        data-testid={testId}
        type={show ? "text" : "password"}
        className={`w-full rounded-lg border border-input bg-background py-3 pl-4 pr-12 text-sm outline-none transition-colors focus:border-primary ${className}`}
      />
      <button
        type="button"
        data-testid={`${testId}-toggle`}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Nascondi password" : "Mostra password"}
        title={show ? "Nascondi password" : "Mostra password"}
        className="absolute inset-y-0 right-2 my-auto flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-white/5 hover:text-foreground"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};
